{
  "users": {
    "label": "Users"
  },
  "userGroups": {
    "label": "Groups"
  },
  "userProfiles": {
    "label": "Profiles"
  }
}
